
import type { PropOptions } from 'vue';
import Vue from 'vue';
import ArrowRightIcon from './images/arrow-right.vue.svg';
import BravadoTextInputV3 from '@/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import CloseIcon from '@/assets/svg/close.vue.svg';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'JobsCustomAction',
  components: {
    BravadoTextInputV3,
    CloseIcon,
    BravadoButtonV3,
    ArrowRightIcon,
  },
  props: {
    mandatory: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    isInputVisible: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  computed: {
    isButtonVisible(): boolean {
      return this.mandatory && this.inputHasValue;
    },
    inputHasValue(): boolean {
      return !!this.$attrs?.value?.trim().length;
    },
  },
  mounted() {
    if (this.inputHasValue) {
      this.showInput();
    }
  },
  methods: {
    showInput(): void {
      this.$emit('toggle-input', true);
      this.$nextTick(() => {
        // @ts-ignore
        this.$refs.input.focus();
      });
    },
    hideInput(): void {
      this.$emit('toggle-input', false);
    },
    handleEnter() {
      if (this.isButtonVisible) {
        this.$emit('click');
      }
    },
  },
});
